// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1SKGq","header":"MergedInvoice_header__SDiUx"};